import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewsListComponent } from './pages/news-list/news-list.page';
import { NewsDetailComponent } from './pages/news-detail/news-detail.page';

export const NewsRoutes: Routes = [
    { path: '', component: NewsListComponent, data: { title: 'News' } },
    { path: ':id', component: NewsDetailComponent, data: { title: 'News' } }
];

@NgModule({
    imports: [RouterModule.forChild(NewsRoutes)],
    exports: [RouterModule]
})
export class NewsRoutingModule { }
